import React from "react";
import { Box, Typography, List, ListItem, ListItemText } from "@mui/material";
import { useLanguage } from "../LanguageContext";

const hosts = {
  en: {
    title: "Conference Host",
    name: "DDr. habil. Agora Zsuzsanna",
    affiliation: "At University of Pécs, Faculty of Cultural Sciences, Education and Regional Development",
    groups: [
      "Culture-Identity-History Interdisciplinary Research Group",
      "Gyula Illyés College for Advanced Studies",
      "Zoltán Dienes Teacher Training College",
      "Centre for Children's Culture Methodology",
      "Research Group on Children's Culture",
    ],
  },
  hu: {
    title: "A konferencia szervezői",
    name: "DDr. habil. Agora Zsuzsanna",
    affiliation: "PTE-KPVK Kultúra-Identitás Történelem Interdiszciplináris Kutatócsoport",
    groups: [
      "PTE-KPVK Illyés Gyula Szakkollégium",
      "PTE-KPVK Dienes Zoltán Pedagógus-továbbképző",
      "PTE-KPVK Gyermekkultúra Módszertani Kutatóközpont",
      "PTE-KPVK Gyermekkultúra Kutatócsoport",
    ],
  },
};

export default function Host() {
  const { language } = useLanguage();
  const hostData = hosts[language];

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#f4f4f4",
        padding: "40px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}>

      {/* Title */}
      <Typography
        variant="h3"
        sx={{
          marginBottom: "30px",
          fontWeight: "bold",
          textAlign: "center",
          color: "#cc0000",
        }}>
        {hostData.title}
      </Typography>

      {/* Host Name */}
      <Typography
        variant="h5"
        sx={{
          marginBottom: "20px",
          fontWeight: "bold",
          textAlign: "center",
          color: "#333",
        }}>
        {hostData.name}
      </Typography>

      {/* Host Affiliation */}
      <Typography
        variant="body1"
        sx={{
          marginBottom: "20px",
          textAlign: "center",
          fontSize: "18px",
          color: "#555",
        }}>
        {hostData.affiliation}
      </Typography>

      {/* Research Groups */}
      <List
        sx={{
          width: "100%",
          maxWidth: "600px",
          backgroundColor: "white",
          boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
          borderRadius: "10px",
          padding: "20px",
        }}>
        {hostData.groups.map((group, index) => (
          <ListItem
            key={index}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              borderBottom: index !== hostData.groups.length - 1 ? "1px solid #ddd" : "none",
              padding: "10px 0",
            }}>
            <ListItemText
              primary={group}
              primaryTypographyProps={{
                variant: "body1",
                fontSize: "16px",
                textAlign: "justify",
                color: "#333",
              }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
}